<template>
  <div id="payment">
    <p class="houseName">缴费房产：{{this.houseName}}</p>
    <div class="paymentDetail">
      <ul>
        <li v-for="(item,index) in items">
          <p class="itemName clear">
            <span class="float-l">费项：</span>
            <span class="float-r span2">{{item.feeitem}}</span>
          </p>
          <p class="amount clear">
            <span class="float-l">金额：</span>
            <span class="float-r span1">{{item.amount}}元</span>
          </p>
          <p class="receiptEnddate clear">
            <span class="float-l">缴费截止日期：</span>
            <span class="float-r span2">{{item.receiptEnddate}}</span>
          </p>
          <p class="feedate clear">
            <span class="float-l">计费日期：</span>
            <span class="float-r span2">{{item.costStartdate}}至{{item.costEnddate}}</span>
          </p>
        </li>
        <li class="footer-li">
          <p class="clear">
            <span class="spa1 float-l">合计金额：</span>
            <span class="spa2 float-r">{{this.amountSum}}元</span>
          </p>
          <p class="clear" v-if="this.discountAmount > 0">
            <span class="spa1 float-l">优惠金额：</span>
            <span class="spa2 spa4 float-r">-{{this.discountAmount}}元</span>
          </p>
          <p class="clear p3">
            <span class="spa3 float-l">实付金额：</span>
            <span class="spa4 float-r">{{this.payableAmount}}元</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

	export default{
		data (){
			return {
				items:[],
				houseName:'',//缴费房产
				amountSum:'', //总金额
        id:'',
        discountAmount:'',
        payableAmount:''
			}
		},
		mounted(){
      let vm = this
			vm.postRequest('payment/order/detail',{
				id:vm.$route.params.id
			},function (data) {
          vm.items=data.paymentDetails
          vm.houseName=data.houseName  //缴费房产
          vm.amountSum=data.amountSum  //总金额
          vm.discountAmount=data.discountAmount
          vm.payableAmount=data.payableAmount
      })
		}
	}
</script>

<style lang="less" scoped>
.clear{
  overflow: hidden;
  zoom: 1;
}
.float-l{
  float: left;
}
.float-r{
  float: right;
}
#payment{
  padding: 35px 26px;
  text-align: left;
}
.houseName{
  line-height: 98px;
  font-size:28px;
  color:rgba(102,102,102,1);
  box-shadow:4px 2px 6px rgba(223,223,223,.82);
  padding-left: 32px;
  box-sizing: border-box;
}
  .paymentDetail li{
    margin-top: 20px;
    line-height: 50px;
    padding: 0 32px;
    font-size: 28px;
    color:rgba(153,153,153,1);
    box-shadow:4px 2px 6px rgba(223,223,223,.82);
  }
.paymentDetail li .span1{
  color: #F7B932;
}
.paymentDetail li .span2{
  font-size: 30px;
  color: #333333;
}
.paymentDetail li:last-child{
  box-shadow: none;
}
.footer-li{
  font-size:28px;
  line-height: 60px;
  color:#666;
}
.footer-li .p3{
  font-size: 36px;
}
.footer-li .spa4{
    color: #F7B932;
}

</style>



// WEBPACK FOOTER //
// src/components/pub-component/pay/paymentDetail.vue